import { useCallback } from "react";
import { useBusyBlockerContext } from "../../contexts/busy-blocker-context";
import { useDashboardContext } from "../../contexts/dashboard-context";
import { useAppContext } from "../../hooks/useAppContext";
import { useErrorHandling } from "../../hooks/useErrorHandling";
import { useLabels } from "../../hooks/useLabels";
import { showRestartProductDialogAsync } from "../dialogs/restart-product-dialog";
import { FloatingMenuItem } from "./floating-menu-item";
import { labels } from "./labels";
import React from "react";

export function RestartMenuItem() {
	const [[restartProduct], areLabelsLoading] = useLabels([labels.restartProduct]);

	const { editor, googleAnalytics } = useAppContext();
	const { busyBlocker } = useBusyBlockerContext();
	const { createErrorHandler } = useErrorHandling();
	const dashboard = useDashboardContext();

	const onRestartClick = useCallback(() => {
		googleAnalytics.trackEventToGa({
			trackingAction: "RestartProjectClicked",
		});

		const restartAsync = () =>
			showRestartProductDialogAsync({ busyBlocker, dashboard, editor });

		restartAsync().catch(createErrorHandler());
	}, [dashboard, busyBlocker, createErrorHandler, editor, googleAnalytics]);

	const canResetDefinition = dashboard.canResetDefinition({ refill: false });

	if (areLabelsLoading) return null;

	return (
		<FloatingMenuItem
			text={restartProduct}
			iconName="restart"
			onClick={onRestartClick}
			disabled={!canResetDefinition}
		/>
	);
}
